import React, { useEffect } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { routes } from "app/routes";
import PageTitle from "../PageTitle";
import { validateMemberToken } from "../../utils/memberToken";

const AppContent = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const validateStoredToken = async () => {
      // Check if we have a stored token that needs validation
      const storedToken = localStorage.getItem("token");
      const needsValidation = localStorage.getItem("memberTokenNeedsValidation");
      
      if (!storedToken || needsValidation !== "true") {
        return;
      }
      
      console.log("MemberToken: Validating stored token");
      
      try {
        const validationResult = await validateMemberToken(storedToken);
        
        if (validationResult.success) {
          console.log("MemberToken: Stored token is valid");
          // Remove validation flag
          localStorage.removeItem("memberTokenNeedsValidation");
        } else {
          console.error("MemberToken: Stored token validation failed:", validationResult.error);
          
          // Clear invalid token
          localStorage.removeItem("token");
          localStorage.removeItem("memberTokenNeedsValidation");
          
          // Save current URL for return after login
          const currentUrl = `${location.pathname}${location.search}`;
          localStorage.setItem("returnUrl", currentUrl);
          
          // Redirect to login
          navigate("/login");
        }
      } catch (error) {
        console.error("Error validating stored token:", error);
        localStorage.removeItem("memberTokenNeedsValidation");
      }
    };
    
    validateStoredToken();
  }, [location, navigate]);

  return (
    <Routes>
      {routes.map((route) => {
        const { path, element } = route;

        let tabName = route.title;
        if (route.title !== "Morph Inspect") {
          tabName = `${route.title} - Morph Inspect`;
        }
        return (
          <Route
            key={path}
            path={path}
            element={<PageTitle title={tabName}>{element}</PageTitle>}
          />
        );
      })}
    </Routes>
  );
};

export default AppContent;